import { Platform } from './integration.types';
import { environment } from '../config/environment';
import { useApiClient } from './api';

/**
 * Hook for user integrations service
 */
export const useUserIntegrationsService = () => {
  const apiClient = useApiClient();

  /**
   * Get user integrations from the backend
   * @returns Array of platforms
   */
  const getUserIntegrations = async (): Promise<Platform[]> => {
    // REMOVED: No longer calling Firebase backend
    return [];
  };

  /**
   * Save user integrations to the backend
   * @param platforms - Array of platforms to save as integrations
   */
  const saveUserIntegrations = async (platforms: Platform[]): Promise<void> => {
    // REMOVED: No longer calling Firebase backend
    return;
  };

  /**
   * Update integration status to 'integrated'
   * @param platformName - Name of the platform to update
   */
  const updateIntegrationStatus = async (platformName: string, platformType: string): Promise<void> => {
    // REMOVED: No longer calling Firebase backend
    return;
  };

  /**
   * Mark integration as removed
   * @param platformName - Name of the platform to mark as removed
   */
  const removeIntegration = async (platformName: string, platformType: string): Promise<void> => {
    // REMOVED: No longer calling Firebase backend
    return;
  };

  /**
   * Get integration setup state
   * @returns Integration setup state ('pending' | 'completed')
   */
  const getIntegrationSetupState = async (): Promise<'pending' | 'completed'> => {
    // REMOVED: No longer calling Firebase backend - always return completed
    return 'completed';
  };

  return {
    getUserIntegrations,
    saveUserIntegrations,
    updateIntegrationStatus,
    removeIntegration,
    getIntegrationSetupState
  };
};




